import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Package } from 'lucide-react';
import ContainersConfigPanel from '../components/ContainersConfigPanel';

/**
 * Standalone page wrapper for the containers configuration panel.
 * The same panel is also embedded as a tab inside AdminContainers.
 */
export default function AdminContainersConfig() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/admin"><Button variant="ghost" size="sm" data-testid="back-to-admin"><ArrowLeft className="w-4 h-4 mr-1" /> Назад</Button></Link>
          <h1 className="text-xl font-semibold flex items-center gap-2"><Package className="w-5 h-5" /> Настройка контейнеров</h1>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        <ContainersConfigPanel />
      </main>
    </div>
  );
}
